import React, { Component } from 'react';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import QuizMiddleware from '../../store/middleware/quizMiddleware';
import { connect } from 'react-redux';
import CircularProgress from '@material-ui/core/CircularProgress';

var user;

class QuizTaker extends Component {
    constructor() {
        super();
        this.state = {
            proctoringKey: "",
            proctoringKeyError1: false,
            proctoringKeyError2: false,
            proctoringKeyError3: false,
            inProgressAnswerSheet : [],
            proctoringKeyLoader : false
        }
    }
    componentWillReceiveProps(nextprops) {
        var userProps = JSON.parse(sessionStorage.getItem('sessionStorageUser'))
        if(!userProps){
            this.props.history.push('/');
        }
        if (nextprops.errorInProctoringKey) {
            this.setState({
                proctoringKeyError2: true,
                proctoringKeyLoader : false
            })
        }

        if (nextprops.networkErrorInProctoringKey) {
            this.setState({
                proctoringKeyError3: true,
                proctoringKeyLoader : false
            })
        }

        if (nextprops.successInProctoringKey === "Success"){ //!nextprops.answerSheet
            if(this.props.location.state.classDetails.additionalFields && this.props.location.state.classDetails.additionalFields.length>0 && this.state.inProgressAnswerSheet.length == 0){
                this.props.history.replace('/quiz/additionalinfo', {additionalFields : this.props.location.state.classDetails.additionalFields, quizDetails : this.props.location.state.quizDetails, userDetails : user, classDetails : this.props.location.state.classDetails})
            }

            else if (nextprops.answerAndQuestionData && nextprops.answerAndQuestionData.question && nextprops.answerAndQuestionData.answerSheet) {
                this.props.history.replace('/quiz/start', { questionDetails: nextprops.answerAndQuestionData.question, answerSheetDetails: nextprops.answerAndQuestionData.answerSheet, quizDetails: this.props.location.state.quizDetails, classDetails : this.props.location.state.classDetails, userDetails: user, time : this.props.location.state.quizDetails.quiz.duration, attemptedQuestions : nextprops.attemptedQuestions, totalQuestions : nextprops.totalQuestions })
            }

            else if (this.state.inProgressAnswerSheet && this.state.inProgressAnswerSheet.length) {
                let answerSheetId;
                answerSheetId = this.state.inProgressAnswerSheet[0]                
                this.props.continueQuiz({
                    answerSheetId : answerSheetId._id,
                    pc_access_token: user.pc_access_token,                    
                })                
            }

            else{
                // this.props.history.push('/quizstart')
                this.startQuiz()
            }
        }
        if(nextprops.remainQuestion && nextprops.remainQuestion.length){
            this.props.history.replace('/quiz/start', { 
                questionDetails: nextprops.remainQuestion,
                answerSheetDetails: this.state.inProgressAnswerSheet[0],
                quizDetails: this.props.location.state.quizDetails,
                userDetails: user,
                classDetails : this.props.location.state.classDetails,
                time : this.props.location.state.quizDetails.quiz.duration - (nextprops.timeConsumed / 60),
                attemptedQuestions : nextprops.attemptedQuestionsInResumeQuiz,
                totalQuestions : nextprops.totalQuestionsInResumeQuiz
            })
        }
        if(nextprops.errorInContinueQuiz){
            this.props.history.replace('/showResult', {
                answerSheetDetails : this.state.inProgressAnswerSheet[0],
                quizDetails: this.props.location.state.quizDetails,
                classDetails :this.props.location.state.classDetails,
                isTimeUp : this.state.inProgressAnswerSheet[0].isTimeUp,
                timeConsumed : this.state.inProgressAnswerSheet[0].timeConsumed,
                userDetails : user
            })
        }

    }

    componentDidMount(){
        let inProgress = [];
        inProgress = this.props.location.state.quizDetails.answerSheet.filter((data) => data.status == 'inProgress')
        this.setState({ inProgressAnswerSheet: inProgress })
    }

    startQuiz(){
        this.props.startQuiz({ 
                    quizId:this.props.location.state.quizDetails.quiz._id ,
                    courseId: this.props.location.state.quizDetails.quiz.course,
                    userId: user._id,
                    pc_access_token: user.pc_access_token,
                    classId: this.props.location.state.classDetails._id
                })
    }

     verifyProctoringKey() {
        if (this.state.proctoringKey) {
            this.setState({
                proctoringKeyLoader : true
            })
            this.props.checkproctoringkey({ quizId: this.props.location.state.quizDetails.quiz._id, proctoringKey: this.state.proctoringKey, courseId: this.props.location.state.quizDetails.quiz.course })
        }
        else {
            this.setState({
                proctoringKeyError1: true
            })
        }
    }

    render() {
        user = JSON.parse(sessionStorage.getItem('sessionStorageUser'))
        return (
            <div style={{ top: "25%", justifyContent: "center", alignItems: "center", display: "flex", width: "100%", flexDirection: "column", position: "absolute" }}>
                <Paper style={{ padding: "25px", maxWidth: "50%", minWidth : "75%" }}>
                    <Typography style={{ fontWeight: "bold", fontSize: "30px" }} >
                        Quiz : {this.props.location.state.quizDetails.quiz.title}
                    </Typography>

                    <TextField
                        disabled={this.props.buttonDisable ? true : null}
                        margin="normal"
                        id="name"
                        label="Enter Proctoring Key"
                        type="password"
                        fullWidth
                        value={this.state.proctoringKey}
                        onChange={(text) => this.setState({ proctoringKey : text.target.value, proctoringKeyError1: false, proctoringKeyError2 : false, proctoringKeyError3 : false })}
                    />
                    
                    <Typography style={this.state.proctoringKeyError1 ? { display: "block", color: 'red', fontSize: '12px' } : { display: "none" }}>* Key is Required</Typography>
                    <Typography style={this.state.proctoringKeyError2 ? { display: "block", color: 'red', fontSize: '12px' } : { display: "none" }}>* {this.props.errorInProctoringKeyMessage}</Typography>
                    <Typography style={this.state.proctoringKeyError3 ? { display: "block", color: 'red', fontSize: '12px' } : { display: "none" }}>* Failed in verify, due to network lost</Typography>
                    <br/><br/><br/>
                    <Typography style={{ display: "block", color: 'red', fontSize: '20px', textAlign: 'justify'  }}>By Clicking on 'Submit Key' button I affirm that I will not give or receive any unauthorized help on this exam, and that all answers selected will be my own. Also, I will not make copies of the exam questions for distribution. If management found any illegal act on my part then management reserve the right to take any action which can include permanently removing me for the program</Typography>

                    {this.state.proctoringKeyLoader ?
                        <div style={{ flexDirection: "column", display: "flex", alignItems: "center", justifyContent: "center", height : "10vh" }}>
                            <CircularProgress size={50} thickness={3} style={{color : "#13a89e"}}/>
                        </div>
                    :
                        <Button disabled={this.props.buttonDisable ? true : null } color={this.props.buttonDisable ? null : "primary"} variant="contained" style={{ float: "right", marginTop : "2%", backgroundColor : "#13a89e"}} onClick={() => this.verifyProctoringKey()}> Submit Key </Button>
                    }

                </Paper>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        successInProctoringKey: state.quizReducer.proctoringKey,
        errorInProctoringKey: state.quizReducer.errorInProctoringKey,
        networkErrorInProctoringKey : state.quizReducer.networkErrorInProctoringKey,
        buttonDisable : state.errorReducer.buttonDisable,
        answerAndQuestionData: state.quizReducer.startQuiz.answerAndQuestionData,
        attemptedQuestions: state.quizReducer.startQuiz.attemptedQuestions,
        totalQuestions: state.quizReducer.startQuiz.totalQuestions,
        remainQuestion : state.quizReducer.continueQuiz.questions,
        timeConsumed : state.quizReducer.continueQuiz.time,
        attemptedQuestionsInResumeQuiz : state.quizReducer.continueQuiz.attemptedQuestions,
        totalQuestionsInResumeQuiz : state.quizReducer.continueQuiz.totalQuestions,
        errorInProctoringKeyMessage : state.quizReducer.errorInProctoringKeyMessage,
        errorInContinueQuiz : state.quizReducer.errorInContinueQuiz
    };
}

function mapDispatchToProps(dispatch) {
    return {
        checkproctoringkey: (data) => dispatch(QuizMiddleware.verifyProctoringKeyMiddleware(data)),
        startQuiz: (data) => dispatch(QuizMiddleware.startQuizMiddleware(data)),
        continueQuiz : (data) => dispatch(QuizMiddleware.continueQuizMiddleware(data))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(QuizTaker);


// WEBPACK FOOTER //
// ./src/container/QuizTaker/quiztaker.js